module.exports = __webpack_public_path__ + "static/media/login_new.e0d7f0f2.png";